import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueSmoothScroll from 'vue2-smooth-scroll'
// Landing styles are global (formerly App.vue's unscoped <style> block). Importing
// them here — not from a component — keeps them present on every route once the
// app becomes multi-view (home + articles), independent of which view is mounted.
import './styles/landing.scss'
import './styles/article.scss'

// The prerendered pages are physically served under /landing/ but exposed at clean
// URLs (/, /articles/...) via a CloudFront rewrite. If someone lands on the raw
// /landing/index.html path, normalise it to '/' BEFORE the router does its initial
// navigation (below) so history-mode routing matches a real route.
if (typeof window !== 'undefined' && window.location.pathname === '/landing/index.html') {
  window.history.replaceState({}, '', '/')
}

// Google Analytics 4 — the same property the Creator app uses (G-J9TC62PFCV),
// loaded only on the production host. dev (creator.eyejack.dev) and staging
// (creator.staging.eyejack.io) are excluded (they also send X-Robots-Tag: noindex).
if (typeof window !== 'undefined' && window.location.hostname === 'creator.eyejack.io') {
  const GA_ID = 'G-J9TC62PFCV'
  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(s)
  window.dataLayer = window.dataLayer || []
  window.gtag = function () { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', GA_ID)
}

Vue.use(vueSmoothScroll, {
  duration: 400,
  updateHistory: true,
  offset: -80
})
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
